import { Component } from '@angular/core';

const template = require('!!raw-loader!./anniversary-party-popper.component.svg').default;

@Component({
    selector: 'anniversary-party-popper',
    template,
    styleUrls: ['./anniversary-party-popper.component.less'],
})
export class AnniversaryPartyPopperComponent {
}
